import { CollapsableGroup } from '@/module/AnnualReport/components/CollapsableGroup';
import { Project } from '@/module/Author/Project';
import { ProjectValidationAction } from '@/module/Author/Project/Validation/ProjectValidationAction';
import { ProjectCard } from '@/module/Author/Project/components/Card/ProjectCard';

interface CollapsableProjectProps {
  title: string;
  projects: Project[];
}

export function CollapsableProject({ title, projects }: CollapsableProjectProps) {
  return (
    <CollapsableGroup
      title={title}
      items={projects}
      renderValidation={project => (
        <ProjectValidationAction
          variant="compact"
          projectId={project.id}
        />
      )}
      renderItem={project => (
        <ProjectCard
          project={project}
          onClick={() => window.open(`/author/project/${project.id}`)}
        />
      )}
    />
  );
}
